import { Location, DatePipe } from '@angular/common';
import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, Router, RouterEvent } from '@angular/router';
import { CoreService } from 'src/app/core/services/core.service';

import { ApproveWorkflowModel, ManageWorkflowService, RejectWorkflowORCModel } from 'src/app/modules/manage-workflows/services/manage-workflow.service';
import { CPNominationDetails } from 'src/app/shared/models/manageWorkflow.model';
import { ENDORSEMENT_APPROVED, FILL_ALL_MANDATORY_FIELDS, NOMINATION_ERROR, NOMINATION_FORM_SUBMITTED, SOMETHING_WENT_WRONG, WORKFLOW_NOT_REJECTED_SUCCESS, WORKFLOW_REJECTED_SUCCESS } from '../../constants/messages';
import { NotificationAlert } from '../../models/notificationAlert.model';
import { DatePipePipe } from '../../pipes/date-pipe.pipe';
import { TextValidator } from '../../validators/textPatternValidator';
import { ToasterNotificationService } from '../toaster-notification/toaster-notification.service';
import {
  IN_REVIEW_URL,
  NOTIFICATION_ERROR,
  MANAGE_WORKFLOWS_URL,
  ORC_MANAGE_WORKFLOWS_URL,
  CP_QP_MANAGE_WORKFLOWS_URL,
  ENDORSER_MANAGE_WORKFLOWS_URL,
  CP_QP_ORC_MANAGE_WORKFLOWS_URL
} from 'src/app/shared/constants/constant';


@Component({
  selector: 'app-cp-nomination',
  templateUrl: './cp-nomination.component.html',
  styleUrls: ['./cp-nomination.component.scss']
})
export class CpNominationComponent implements OnInit, OnChanges {
  public showLoader = false;
  public alert: NotificationAlert = null;
  public nominationFormGroupControl: FormGroup;
  public editNoninationForm = false;
  public nomination: any;
  public assingId: string;
  public workflowID: string;
  public yearCode: string;
  public disableInputFields = false;
  public workflowStatus: string;
  public workflowUser: any;
  public showSubmitSuccessPopup = false;
  public successMessage: string;
  public commentControl: FormControl = null;
  public showRejectedPopup = false;
  public submitCommentForm = false;
  public submitNominationForm = false;
  public disableSubmitButton = false;
  public isReportingCycleLocked = false;
  public rejectBy: string;
  public showErrorMessage = false;
  public isAdmin = false;
  public isEndorser = false;
  public isCPQP = false;
  public isORC = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _location: Location,
    private manageWorkflowService: ManageWorkflowService,
    private toasterNotificationService: ToasterNotificationService,
    private coreService: CoreService,
    private manageWorkflow: ManageWorkflowService) {
    this.route.params.subscribe(params => {
      try {
        this.assingId = params.id;
        this.workflowID = params.workflowId;
        this.yearCode = params.yearCode;
        // if (params.workflowID) {}
      }
      catch (exception) {
        //this.router.navigateByUrl('');
      }
    });
  }

  ngOnInit(): void {
    this.showLoader = true;
    this.isReportingCycleLocked = sessionStorage.getItem('isCurrentReportingCycleYearLock') === '1';
    if (this.router.url.indexOf(ENDORSER_MANAGE_WORKFLOWS_URL) > -1) {
      this.isEndorser = true;
    } else if (this.router.url.indexOf(CP_QP_MANAGE_WORKFLOWS_URL) > -1) {
      this.isCPQP = true;
    } else if (this.router.url.indexOf(CP_QP_ORC_MANAGE_WORKFLOWS_URL) > -1) {
      if (this.router.url.indexOf(IN_REVIEW_URL) > -1) {
        this.isORC = true;
      } else {
        this.isCPQP = true;
      }
    } else if (this.router.url.indexOf(ORC_MANAGE_WORKFLOWS_URL) > -1) {
      this.isORC = true;
    } else if (this.router.url.indexOf(MANAGE_WORKFLOWS_URL) > -1) {
      this.isAdmin = true;
    }
    this.manageWorkflowService.getNominationDetails(this.workflowID, this.yearCode).subscribe(
      (response) => {
        this.showLoader = false;
        const isDataAvailable = true;
        this.disableInputFields = false;
        this.nomination = response;
        this.workflowStatus = this.nomination.workflowStatus;
        this.workflowUser = this.nomination.workflowUser;
        let nominationtext = this.nomination.nominationText;

        var elementId = window.document.getElementById("renderData");
        if (this.workflowStatus === '1' && this.isCPQP && !this.isReportingCycleLocked) {
          nominationtext = nominationtext.replace('[checkbox1]', '<input type=checkbox class=nominationck id=isMineralResources name=checkbox1 value=checkbox1>');
          nominationtext = nominationtext.replace('[checkbox2]', '<input type=checkbox class=nominationck id=isOreReserves name=checkbox2 value=checkbox2>');
          nominationtext = nominationtext.replace('[checkbox3]', '<input type=checkbox class=nominationck id=isSME name=checkbox3 value=checkbox3>');
          nominationtext = nominationtext.replace('[checkbox4]', '<input type=checkbox class=nominationck id=isMineralResourcesUssec name=checkbox4 value=checkbox4>');
          nominationtext = nominationtext.replace('[checkbox5]', '<input type=checkbox class=nominationck id=isMineralReservesUssec name=checkbox5 value=checkbox5>');
          nominationtext = nominationtext.replace('[checkbox6]', '<input type=checkbox class=nominationck id=isSMEUssec name=checkbox6 value=checkbox6>');
          nominationtext = nominationtext.replace('[checkbox7]', '<input type=checkbox class=nominationck id=isExplorationResults name=checkbox7 value=checkbox7>');
          nominationtext = nominationtext.replace('[checkbox8]', '<input type=checkbox class=nominationck id=isExplorationResultsUssec name=checkbox8 value=checkbox8>');
          nominationtext = nominationtext.replace('[checkbox9]', '<input type=checkbox class=nominationck id=isCompillingPreviously name=checkbox9 value=checkbox9>');
          nominationtext = nominationtext.replace('[checkbox10]', '<input type=checkbox class=nominationck id=isCompilingCurrently name=checkbox10 value=checkbox10>');
        } else {
          nominationtext = nominationtext.replace('[checkbox1]', '<input type=checkbox class=nominationck id=isMineralResources name=checkbox1 value=checkbox1 disabled>');
          nominationtext = nominationtext.replace('[checkbox2]', '<input type=checkbox class=nominationck id=isOreReserves name=checkbox2 value=checkbox2 disabled>');
          nominationtext = nominationtext.replace('[checkbox3]', '<input type=checkbox class=nominationck id=isSME name=checkbox3 value=checkbox3 disabled>');
          nominationtext = nominationtext.replace('[checkbox4]', '<input type=checkbox class=nominationck id=isMineralResourcesUssec name=checkbox4 value=checkbox4 disabled>');
          nominationtext = nominationtext.replace('[checkbox5]', '<input type=checkbox class=nominationck id=isMineralReservesUssec name=checkbox5 value=checkbox5 disabled>');
          nominationtext = nominationtext.replace('[checkbox6]', '<input type=checkbox class=nominationck id=isSMEUssec name=checkbox6 value=checkbox6 disabled>');
          nominationtext = nominationtext.replace('[checkbox7]', '<input type=checkbox class=nominationck id=isExplorationResults name=checkbox7 value=checkbox7 disabled>');
          nominationtext = nominationtext.replace('[checkbox8]', '<input type=checkbox class=nominationck id=isExplorationResultsUssec name=checkbox8 value=checkbox8 disabled>');
          nominationtext = nominationtext.replace('[checkbox9]', '<input type=checkbox class=nominationck id=isCompillingPreviously name=checkbox9 value=checkbox9 disabled>');
          nominationtext = nominationtext.replace('[checkbox10]', '<input type=checkbox class=nominationck id=isCompilingCurrently name=checkbox10 value=checkbox10 disabled>');
        }
        elementId.innerHTML = nominationtext

        if (this.nomination.workflowStatus !== '1' || !this.isCPQP || this.isReportingCycleLocked || this.yearCode !== sessionStorage.getItem('currentReportingCycleYear')) {
          this.disableInputFields = true;
        }

        document.getElementById('isMineralResources')['checked'] = Number(this.nomination.isMineralResources);
        document.getElementById('isOreReserves')['checked'] = Number(this.nomination.isOreReserves);
        document.getElementById('isSME')['checked'] = Number(this.nomination.isSME);
        document.getElementById('isMineralResourcesUssec')['checked'] = Number(this.nomination.isMineralResourcesUssec);
        document.getElementById('isMineralReservesUssec')['checked'] = Number(this.nomination.isMineralReservesUssec);
        document.getElementById('isSMEUssec')['checked'] = Number(this.nomination.isSMEUssec);
        document.getElementById('isExplorationResults')['checked'] = Number(this.nomination.isExplorationResults);
        document.getElementById('isExplorationResultsUssec')['checked'] = Number(this.nomination.isExplorationResultsUssec);
        document.getElementById('isCompillingPreviously')['checked'] = Number(this.nomination.isCompillingPreviously);
        document.getElementById('isCompilingCurrently')['checked'] = Number(this.nomination.isCompilingCurrently);

        document.getElementById('isMineralResources').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isOreReserves').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isSME').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isMineralResourcesUssec').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isMineralReservesUssec').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isSMEUssec').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isExplorationResults').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isExplorationResultsUssec').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isCompillingPreviously').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };
        document.getElementById('isCompilingCurrently').onclick = (event) => {
          this.checkUncheckOptions(event);
          this.showHideNominationErrorMessage();
        };

        this.nominationFormGroupControl = this.getNominationFormGroup(isDataAvailable, response);
      });
  }

  ngOnChanges(changes: SimpleChanges): void { }

  public showHideNominationErrorMessage(): void {
    if (!document.getElementById('isMineralResources')['checked']
      && !document.getElementById('isOreReserves')['checked']
      && !document.getElementById('isSME')['checked']
      && !document.getElementById('isMineralResourcesUssec')['checked']
      && !document.getElementById('isMineralReservesUssec')['checked']
      && !document.getElementById('isSMEUssec')['checked']
      && !document.getElementById('isExplorationResults')['checked']
      && !document.getElementById('isExplorationResultsUssec')['checked']
      && !document.getElementById('isCompillingPreviously')['checked']
      && !document.getElementById('isCompilingCurrently')['checked']) {
      document.getElementById('errorMessage').style.display = 'block';
      this.showErrorMessage = true;
    } else {
      document.getElementById('errorMessage').style.display = 'none';
      this.showErrorMessage = false;
    }
  }


  public checkUncheckOptions(event): void {
    var chkBoxes = document.querySelectorAll("#renderData input[type='checkbox']");
    chkBoxes.forEach((item: any) => {
      if (event.target.id !== item.id) {
        document.getElementById(item.id)['checked'] = 0;
      }
    });
  }

  public getNominationFormGroup(isDataAvailable: boolean, nomination: any): any {
    const formFields: any = {};
    let todaysDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy h:mm:ss a');
    const scope = { value: nomination.scope, disabled: this.disableInputFields };

    const nominationTerm = { value: this.workflowStatus <= '1' ? null : 1, disabled: this.disableInputFields };

    const signedAcceptance = { value: nomination.cpqpName, disabled: isDataAvailable || this.disableInputFields };
    const signedEndorsement = { value: nomination.endorserName, disabled: isDataAvailable || this.disableInputFields };
    const signedApproval = { value: nomination.approverName, disabled: isDataAvailable || this.disableInputFields };

    const signedAcceptanceDate = {
      value: nomination.cpqpSubmittedDate ?
        new DatePipePipe().transform(nomination.cpqpSubmittedDate) : '', disabled: isDataAvailable || this.disableInputFields
    };
    if (this.isORC === true && (nomination.endorsementDate === null || nomination.endorsementDate === '')) {
      nomination.endorsementDate = todaysDate;
    }
    const signedEndorsementDate = {
      value: nomination.endorsementDate ?
        new DatePipePipe().transform(nomination.endorsementDate) : '', disabled: isDataAvailable || this.disableInputFields
    };
    if (this.isEndorser === true && (nomination.approvedDate === null || nomination.approvedDate === '')) {
      nomination.approvedDate = todaysDate;
    }
    const signedApprovalDate = {
      value: nomination.approvedDate ?
        new DatePipePipe().transform(nomination.approvedDate) : '', disabled: isDataAvailable || this.disableInputFields
    };

    formFields.scope = new FormControl(scope, [Validators.required, TextValidator(500)]);
    formFields.nominationTerm = new FormControl(nominationTerm, [Validators.required]);

    formFields.signedAcceptance = new FormControl(signedAcceptance, [Validators.required]);
    formFields.signedEndorsement = new FormControl(signedEndorsement, [Validators.required]);
    formFields.signedApproval = new FormControl(signedApproval, [Validators.required]);

    formFields.signedAcceptanceDate = new FormControl(signedAcceptanceDate, [Validators.required]);
    formFields.signedEndorsementDate = new FormControl(signedEndorsementDate, [Validators.required]);
    formFields.signedApprovalDate = new FormControl(signedApprovalDate, [Validators.required]);
    return new FormGroup(formFields);
  }

  public onCancel(): void {
    this._location.back();
  }

  public onSubmitNomination(): void {
    this.submitNominationForm = true;
    this.showLoader = true;
    this.alert = null;
    this.showHideNominationErrorMessage();
    if (!this.showErrorMessage &&
      this.nominationFormGroupControl.valid &&
      (this.nominationFormGroupControl.controls.nominationTerm && this.nominationFormGroupControl.controls.nominationTerm.value)) {
      const nominationDetails = this.nominationFormGroupControl.getRawValue();
      if (this.nomination.affiliationDate !== undefined && this.nomination.affiliationDate !== null && this.nomination.affiliationDate !== '') {
        let affiliationDate = this.nomination.affiliationDate.toString().split('/');
        this.nomination.affiliationDate = affiliationDate[2] + '' + affiliationDate[1] + '' + affiliationDate[0];
      }
      const data = {
        yearCode: this.yearCode,
        workflowID: this.workflowID,
        loginID: this.coreService.getLoggedInID(),
        scope: nominationDetails.scope || this.nomination.scope,
        nameOfCompany: this.nomination.nameOfCompany,
        CPQPName: this.nomination.cpqpName,
        CPQPTitle: this.nomination.cpqpTitle,
        personalPronouns: this.nomination.personalPronouns,
        possesiveDeterminers: this.nomination.possesiveDeterminers,
        isMineralResources: document.getElementById('isMineralResources')['checked'] ? '1' : '0',
        isOreReserves: document.getElementById('isOreReserves')['checked'] ? '1' : '0',
        isSME: document.getElementById('isSME')['checked'] ? '1' : '0',
        isMineralResourcesUssec: document.getElementById('isMineralResourcesUssec')['checked'] ? '1' : '0',
        isMineralReservesUssec: document.getElementById('isMineralReservesUssec')['checked'] ? '1' : '0',
        isSMEUssec: document.getElementById('isSMEUssec')['checked'] ? '1' : '0',
        isExplorationResults: document.getElementById('isExplorationResults')['checked'] ? '1' : '0',
        isExplorationResultsUssec: document.getElementById('isExplorationResultsUssec')['checked'] ? '1' : '0',
        isCompillingPreviously: document.getElementById('isCompillingPreviously')['checked'] ? '1' : '0',
        isCompilingCurrently: document.getElementById('isCompilingCurrently')['checked'] ? '1' : '0',
        MembershipCategory: this.nomination.membershipCategory,
        NameOfDeposit: this.nomination.nameOfDeposit,
        currentYear: this.nomination.currentYear,
        membershipCategory: this.nomination.membershipCategory,
        professionalOrganizationName: this.nomination.professionalOrganizationName,
        affiliationDate: this.nomination.affiliationDate,
        reserveResource: this.nomination.reserveResource,
        templateID: this.nomination.templateID
      };
      this.manageWorkflowService.submitForReview(data).subscribe((resolve) => {
        this.showLoader = false;
        this.showSubmitSuccessPopup = true;
        this.submitNominationForm = false;
        this.successMessage = NOMINATION_FORM_SUBMITTED;
      }, (error) => {
        this.toasterNotificationService.showErrorNotification(NOMINATION_ERROR);
      });
    } else {
      this.showLoader = false;
      this.alert = { type: NOTIFICATION_ERROR, message: FILL_ALL_MANDATORY_FIELDS };
    }
  }

  public onEndorserReject(): void {
    this.rejectBy = 'Endorser';
    this.commentControl = new FormControl(null, [Validators.required, TextValidator(300)]);
    this.showRejectedPopup = true;
    this.submitCommentForm = false;
  }

  public onORCApprove(): void {
    this.showLoader = true;
    const data: ApproveWorkflowModel = {
      loginID: this.coreService.getLoggedInID().toString(),
      workflowID: this.workflowID,
      yearCode: this.yearCode,
      rejectReason: null
    };
    this.manageWorkflow.approveByORCWorkflow(data)
      .subscribe((resolve) => {
        this.showLoader = false;
        this.successMessage = ENDORSEMENT_APPROVED;
        this.showSubmitSuccessPopup = true;
      }, (error) => {
        this.showLoader = false;
        this.alert = { type: NOTIFICATION_ERROR, message: SOMETHING_WENT_WRONG };
      });
  }

  public onEndorserApprove(): void {
    this.showLoader = true;
    const data: ApproveWorkflowModel = {
      loginID: this.coreService.getLoggedInID().toString(),
      workflowID: this.workflowID,
      yearCode: this.yearCode,
      rejectReason: null
    };
    this.manageWorkflow.approveByEndorser2(data)
      .subscribe((resolve) => {
        this.showLoader = false;
        this.successMessage = ENDORSEMENT_APPROVED;
        this.showSubmitSuccessPopup = true;
      }, (error) => {
        this.showLoader = false;
        this.alert = { type: NOTIFICATION_ERROR, message: SOMETHING_WENT_WRONG };
      });
  }

  public onRejectUpdateRequired(): void {
    this.rejectBy = 'ORC';
    this.commentControl = new FormControl(null, [Validators.required, TextValidator(300)]);
    this.showRejectedPopup = true;
    this.submitCommentForm = false;
  }

  public onRejectApplicant(): void {
    this.rejectBy = 'Applicant';
    this.commentControl = new FormControl(null, [Validators.required, TextValidator(300)]);
    this.showRejectedPopup = true;
    this.submitCommentForm = false;
  }

  public confirmRejection(): void {
    this.submitCommentForm = false;
    if (this.rejectBy === 'ORC' || this.rejectBy === 'Applicant') {
      this.submitCommentForm = true;
      if (this.commentControl.valid) {
        const data: RejectWorkflowORCModel = {
          isNomination: this.rejectBy === 'Applicant' ? '1' : '0',
          loginID: this.coreService.getLoggedInID().toString(),
          workflowID: this.workflowID,
          yearCode: this.yearCode,
          rejectReason: this.commentControl.value
        };
        this.showLoader = true;
        this.manageWorkflow.rejectedByORCWorkflow(data)
          .subscribe((resolve) => {
            setTimeout(() => {
              this.goBackToCPNominations();
              this.toasterNotificationService.showSuccessNotification(WORKFLOW_REJECTED_SUCCESS);
              this.showLoader = false;
            }, 1000);
          }, (error) => {
            this.showLoader = false;
            this.alert = { type: NOTIFICATION_ERROR, message: WORKFLOW_NOT_REJECTED_SUCCESS };
          });
      } else {
        this.showLoader = false;
      }
    } else if (this.rejectBy === 'Endorser') {
      this.submitCommentForm = true;
      if (this.commentControl.valid) {
        this.showLoader = true;
        const data: RejectWorkflowORCModel = {
          isNomination: '0',
          loginID: this.coreService.getLoggedInID().toString(),
          workflowID: this.workflowID,
          yearCode: this.yearCode,
          rejectReason: this.commentControl.value
        };
        this.manageWorkflow.rejectedByEndorser2(data)
          .subscribe((resolve) => {
            this.showLoader = false;
            this.toasterNotificationService.showSuccessNotification(WORKFLOW_REJECTED_SUCCESS);
            this.goBackToCPNominations();
          }, (error) => {
            this.showLoader = false;
            this.alert = { type: NOTIFICATION_ERROR, message: WORKFLOW_NOT_REJECTED_SUCCESS };
          });
      } else {
        this.showLoader = false;
      }
    }
  }

  public closeRejectionPopup(): void {
    this.showRejectedPopup = false;
    this.commentControl = null;
    this.submitCommentForm = false;
  }

  public goBackToCPNominations(): void {
    if (this.router.url) {
      this.router.navigateByUrl(this.router.url.substr(1, this.router.url.indexOf('/cp-nomination')).slice(0, -1));
    }
  }



}
